import { Progress, ProgressProps } from "antd";

const ProgressNoPerc = ({ ...props }: ProgressProps) => {
  return <Progress className="noPercentage" {...props} />;
};
export default ProgressNoPerc;
